export default __webpack_public_path__ + "static/webRotator/svg/c4e6c62db37bd95072dd5f682f20d39e.svg";